


















































































import Vue from 'vue';
import AceEditor from './editor/ace.vue';
import { mapState, mapMutations } from 'vuex';
import { fetchPointData } from './utils/fetchPointData';
import { excuteScriptCode } from './utils/excuteScriptCode';
import { DataSource } from './types/interface';
// 弹窗延迟
const popoverDelay = 50;
export default Vue.extend({
    data() {
        return {
            isDebug: false,
            filterCode: '',
            
            // 调试模块的输入输出数据
            inputData: '',
            outputData: '',
            pointData: '',

            // editor编辑器的引用
            originEditorRef: {},
            inputEditorRef: {},
            outputEditorRef: {},

            editorloading: false,

            // 测点数据请求的值
            pointReqData: '',

            // 代码是否保存
            codeHasSave: true,
        }
    },
    props: {
        drawerVisble: Boolean,
    },
    components: {
        AceEditor
    },
    computed: {
        ...mapState({
            partSelection: (state: any) => state.screen.editor.partSelection,
            // vuex层的数据源
            dataSource: (state: any) => state.screen.editor.dataSource,
        }),
        /**
         * 被选中的part数组
         */
        selectGroup(): Model.Part[] {
            return this.partSelection.selectGroup
        },
        /**
         * 当前选中的part
         * 目前只处理单个part
         */
        curSelectPart(): Model.Part {
            const { length } = this.selectGroup
            return length === 1 ? this.selectGroup[0] : {}
        },
        partData(): any {
            const partData = this.curSelectPart.partData;
            return partData;
        },
        popVisible(): boolean {
            return this.isDebug;
        },
        sourceType(): number {
            return this.partData && this.partData.sourceType || 0;
        },
        // 启用过滤器
        useScript: {
            get(): string {
                return (this.partData && this.partData.useScript) || false;
            },
            set(isUseScript: string): void {
                if (!isUseScript) {
                    this.isDebug = false;
                }
                setTimeout(() => {
                    const option = {
                        useScript: isUseScript,
                    }
                    this.set_partData(option);
                }, popoverDelay);
            }
        },
        sourceData() {
            return this.partData && this.partData.staticData && this.partData.staticData.sourceData;
        },
        // 展示数据的缓存
        displayDataPool(): string {
            return this.dataSource &&  this.dataSource.displayData || '[]';
        },
        drawerStatus() {
            return this.dataSource &&  this.dataSource.drawerStatus || false;
        },
        scriptData: {
            get(): string {
                return (this.partData && this.partData.scriptLog) || 'return data';
            },
            set(newScriptData: string): void {
                const option = {
                    scriptLog: newScriptData,
                }
                this.set_partData(option);
            }
        },
    },
    watch: {
        drawerVisble(newValue) {
            if (!newValue) {
                // 初始化开启测试，
                this.isDebug = false;
                // 初始化输出测试数据
                this.outputData = '[]';
            } else {
                // 初始化输入数据
                this.updataInputData();
            }
        },
        // 监听测点请求的数据
        pointReqData() {
            // 更新输入数据
            this.updataInputData();

        },
        useScript(isUseScript: boolean) {
            // 更新编辑器的代码内容
            if (isUseScript) {
                this.updateScriptData();
            }
        },
        /**
         * 监听是否开启调试
         * 主要用途是用于测点请求数据的判断，
         * 如果是开启了测点调试，展示数据模块不需要请求数据，由调试请求
         */
        isDebug(newIsDebug: boolean) {
            (this.$root as any).busRef.$emit('changeEditorTest', newIsDebug)
        },
        /**
         * 监听抽屉的开关
         */
        drawerStatus(): void {
            if(!this.drawerStatus) {
                return;
            }
            this.updateScriptData();
        }
    },
    methods: {
        ...mapMutations([
            'set_partData',
        ]),
        /**
         * 更新输入数据
         */
        updataInputData() {
            let initInputData = '[]';
            if (this.sourceType === DataSource.Static) {
                initInputData = this.sourceData;
            } else if (this.sourceType === DataSource.Point){
                initInputData = this.pointReqData;
            }
            this.inputData = initInputData;
        },
        useScriptChange() {
            // 更新过滤数据
            setTimeout(() => {
                this.onEmitScriptChange();
            }, popoverDelay);
        },
        /**
         * 执行调试
         * 1. 数据从initInputData输入源中获取
         */
        excuteDebug() {
            // 获取输入数据
            const inputSourceData: any = _.isEmpty(this.curSelectPart) ? [] : JSON.parse(this.inputData);
            // 输入数据，输入用户代码
            const outpuSourcetData = excuteScriptCode(inputSourceData, this.scriptData);
            // 输入转化数据
            this.outputData = JSON.stringify(outpuSourcetData, null, 2);
        },
        /**
         * 保存脚本代码
         * 其实数据变更就已经缓存了脚本
         */
        saveScriptLog() {
            // 关闭调试按钮
            this.isDebug = false;

            // 执行展示数据的更新
            this.onEmitScriptChange();

            this.$message.success('保存成功');
            // 设置为已保存状态
            this.codeHasSave = true;
        },
        /**
         * 更新过滤器代码
         */
        updateFilterCode(filterCode: any) {
            // 比较代码是否相同
            if (filterCode === this.scriptData) {
                return;
            }
            this.codeHasSave = false;
            this.scriptData = filterCode;
        },
        /**
         * 发射脚本编辑改变的事件
         */
        onEmitScriptChange() {
            (this.$root as any).busRef.$emit('scriptChange');
        },
        /**
         * 初始化编辑器的引用
         * @editor 编辑器实例的引用
         */
        onMountedEditor(editor: any) {
            this.originEditorRef = editor;
        },
        mountedInputEditorRef(editor: any) {
            this.inputEditorRef = editor;
        },
        mountedOutputEditorRef(editor: any) {
            this.outputEditorRef = editor;
        },
        /**
         * 监听测点发生改变，请求数据
         * 测点发生改变，增加删除修改
         * 1. 开启调试，由输入请求数据
         * 2. 调试关闭，由展示请求数据
         */
        onListenerFetchPoint(isDestroyed?: boolean): void {
            if (isDestroyed) {
                (this.$root as any).busRef.$off('fetchPoint');
                return;
            }
            (this.$root as any).busRef.$on('fetchPoint', () => {
                if (this.isDebug) {
                    this.fetchPointInputData();
                }
            });
        },
        /**
         * 监听静态数据发生改变
         * 静态数据编辑器失去焦点
         * 1. 开启调试，由输入请求数据
         * 2. 调试关闭，由展示请求数据
         */
        onListenerStaticData(isDestroyed?: boolean) {
            if (isDestroyed) {
                (this.$root as any).busRef.$off('fetchStatic');
                return;
            }
            (this.$root as any).busRef.$on('fetchStatic', (message) => {
                // 如果调试状态，不需要更新静态数据
                if (this.isDebug) {
                    this.fetchStaticData();
                }
            });
        },
        fetchPointInputData() {
            // 如果调试状态，不需要请求数据
            if (!this.isDebug) {
                this.onEmitScriptChange();
                return;
            }
            this.editorloading = true;
            fetchPointData().then(
                (success: any) => {
                    this.pointReqData = JSON.stringify(success, null, 2)
                    this.editorloading =false;
                    // this.onEmitScriptChange(this.pointReqData);
                },
                (error: any) => {
                    // 将错误提交到告警中心
                    this.editorloading =false;
                }
            );
        },
        fetchStaticData() {
            let displayData = '';
            if (this.sourceData && _.isString(this.sourceData)) {
                try {
                    displayData = JSON.parse(this.sourceData);
                } catch (error) {
                    displayData = '编辑器输入内容有误';
                }
            }
            this.pointReqData = JSON.stringify(displayData, null, 2)
        },
        debugChange() {
            if (this.isDebug && this.sourceType === DataSource.Point) {
                this.fetchPointInputData();
            } else if (this.isDebug && this.sourceType === DataSource.Static){
                this.fetchStaticData();
            }
            this.updateIOEditorData();
        },
        /**
         * 更新编辑器输入输出的内容数据
         * fiexme 编辑器内容不更新
         * 触发：1. 开启过滤器 2. 打开调试
         */
        updateIOEditorData() {
            this.$nextTick( () => {
                (this.inputEditorRef as any).alignCursors();
                (this.outputEditorRef as any).alignCursors();
            });
        },
        /**
         * 更新脚本编辑的数据
         * 触发：1. 开启过滤器 2. 切换抽屉状态
         */
        updateScriptData() {
            this.$nextTick( () => {
                (this.originEditorRef as any).alignCursors();
            });
        },
    },
    mounted() {
        this.updataInputData();
        this.onListenerFetchPoint();
        this.onListenerStaticData();
    },
    beforeDestroy() {
        this.originEditorRef = null;
        this.onListenerFetchPoint(true);
        this.onListenerStaticData(true);
    }
})
